import type { DataTableFilterMetaData, DataTableOperatorFilterMetaData } from 'primevue/datatable'
import type { PagingSortingFilteringDetails } from '@/types/paging/paging-sorting-filtering-details.model'

export function useMapPagingSortingFilteringDetails(value: PagingSortingFilteringDetails): PagingSortingFilteringDetails {
  const cloned = JSON.parse(JSON.stringify(value)) as PagingSortingFilteringDetails

  for (const key in cloned.filters) {
    const operatorFilter = cloned.filters[key] as DataTableOperatorFilterMetaData

    if (operatorFilter.constraints) {
      const operatorFilterConstraintsLength = operatorFilter.constraints.length

      for (let constraintIndex = 0; constraintIndex < operatorFilterConstraintsLength; constraintIndex++) {
        const constraint = operatorFilter.constraints[constraintIndex]

        if (!constraint) {
          continue
        }

        if (typeof constraint.value === 'boolean' || typeof constraint.value === 'number') {
          constraint.value = constraint.value.toString()
        }
      }
    }
    else {
      const filter = cloned.filters[key] as DataTableFilterMetaData

      if (typeof filter.value === 'boolean' || typeof filter.value === 'number') {
        filter.value = filter.value.toString()
      }

      if (filter) {
        const newOperatorFilter: DataTableOperatorFilterMetaData = {
          operator: 'AND',
          constraints: [filter],
        }

        cloned.filters[key] = newOperatorFilter
      }
    }
  }

  return cloned
}
